import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import React, { useState } from "react"
import { Accordion, Card } from "react-bootstrap"
import { injectIntl } from "react-intl"
import IntlProps from "../../state/helpers/IntlProps"
import "./accordion.scss"

type OwnProps = {
    lines: {
        header: string
        content: string
    }[]
}

const StyledAccordion = (props: OwnProps & IntlProps) => {
    const [activeKey, setActiveKey] = useState<string>("")

    return (
        <Accordion>
            {props.lines.map((line, i) => (
                <Card key={i}>
                    <Accordion.Toggle
                        as={Card.Header}
                        eventKey={`${i}`}
                        onClick={() => setActiveKey(activeKey === `${i}` ? "" : `${i}`)}
                    >
                        {line.header}
                        <FontAwesomeIcon className={activeKey === `${i}` ? "active" : ""} icon="angle-down" size="lg" />
                    </Accordion.Toggle>
                    <Accordion.Collapse eventKey={`${i}`}>
                        <Card.Body>{line.content}</Card.Body>
                    </Accordion.Collapse>
                </Card>
            ))}
        </Accordion>
    )
}

export default injectIntl(StyledAccordion)


// WEBPACK FOOTER //
// ./src/common/accordion/accordion.tsx